function Setlist(method, view, artist_id, setlist_id) {
    this.method = method;
    this.url = '/artists/' + artist_id + '/artist_setlists/';

    if (setlist_id !== undefined) {
        this.url += setlist_id;
    }
    if (view === 'artist') {
        this.datatable = $('#artist-setlists-datatable').dataTable();
    }
    this.edit_modal = $('#generic-edit-modal');
}

Setlist.prototype.ajax_call = function(params) {
    var self = this;
    var data;
    if (params !== undefined) data = params;
    $.ajax({
        url         : self.url,
        type        : self.method,
        dataType    : 'json',
        data        : data,
        success     : function(data) {
            if (data.notice) {
                showNotification(data.notice);
                if (self.method !== 'DELETE') self.edit_modal.modal('hide');
                self.datatable.fnDraw(false);
            } else if (data.error) {
                showNotification(data.error, 'danger');
                if (self.method !== 'DELETE') $('#submit').prop('disabled',false);
            }
        },
        error : function (request, status, error) {
            showNotification(request.responseText, 'danger', 'Error in ajax call!');
        }
    });
};

global.load_setlist_edit_form = function (element, event, redirect_code, header) {
    event.preventDefault();
    var target_url = $(element).attr('href');
    if (target_url.length) {
        $('#generic-edit-modal .modal-header h3').text(header);
        $('#generic-edit-modal').modal('show');
        $.ajax({
            url         : target_url,
            data        : {
                redirect_to_view : redirect_code
            },
            success     : function(data) {
                if (data.length) {
                    $('#generic-edit-modal .modal-container').html(data);
                    initDatePickerElements();
                }
            }
        });
    }
}

window.delete_artist_setlist = function(params) {
    if (params.length == 2) {
        var artist_id = params[0];
        var setlist_id = params[1];
        var artist_setlist = new Setlist('DELETE', 'artist', artist_id, setlist_id);
        artist_setlist.ajax_call();
    }
}

$(document).on('submit', '.setlist_form', function(event) {
    event.preventDefault();
    var _this = $(this);
    var view = _this.data('view');
    var artist_id = _this.data('artist-id');
    var setlist_id = _this.data('id');
    var ajax_method = 'POST';
    if (setlist_id !== undefined) ajax_method = 'PUT';

    var artist_setlist = new Setlist(ajax_method, view, artist_id, setlist_id);
    artist_setlist.ajax_call(_this.serialize());
});

function setlists_ready() {
    if (CURRENT_CONTROLLER !== 'setlists') return;

    if($('#setlist-items').hasClass('sortable')) {
        $("#setlist-items").sortable({
            start: function(event, ui) {
                ui.item.addClass("row_dragged");
            },
            stop: function(event, ui) {
                ui.item.removeClass("row_dragged");
            },
            update: function(event, ui) {
                $('#setlist-items tr').each(function(index, row) {
                    // Let's refresh the position for each setlist item row
                    $(row).find('input:hidden[class="item_position"]').val(index + 1);
                });
            }
        });
    }
}

$(document).on('turbolinks:load', setlists_ready);